import { Divider, DialogContent } from '@mui/material';
import AppSimpleDialog from 'app/shared-components/dialogs/AppSimpleDialog';

import FiltersForm, { FilterField, FiltersFormValues } from './FiltersForm';

interface IProps {
  open: boolean;
  fields: FilterField[];
  selectedFilters?: FiltersFormValues;

  handleClose: () => void;
  onFiltersClear: () => void;
  onFiltersApply: (v: FiltersFormValues) => void;
}

const FiltersDialog = ({
  open,
  handleClose,
  fields: options,
  onFiltersApply,
  onFiltersClear,
  selectedFilters,
}: IProps) => {
  return (
    <AppSimpleDialog open={open} handleClose={handleClose} title="Filters" size="md" scroll="paper">
      <Divider />

      <DialogContent className="px-24">
        <FiltersForm
          selectedFilters={selectedFilters}
          fields={options}
          onFiltersApply={onFiltersApply}
          onFiltersClear={onFiltersClear}
        />
      </DialogContent>
    </AppSimpleDialog>
  );
};

export default FiltersDialog;
